import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class SignInCommand extends RequestData<void> {
  constructor(
    public readonly email: string,
    public readonly password: string,
  ) {
    super()
  }
}

export const signIn = (email: string, password: string) =>
  mediator.send(new SignInCommand(email, password))
